<template>
  <el-dialog title="添加用户" :visible.sync="visible" @opened="openDialog" class="addUserDialog" @close="closeDialog"
    :append-to-body="true" :close-on-click-modal="false" :class="visible ? 'flip-in-hor-bottom' : ''">
    <div>
      <div style="display: flex; height: 480px;justify-content: center;">
        <el-form label-position="left" label-width="7rem" :model="formLabelAlign" :rules="rules" ref="formLabelAlign">
          <div style="padding: 2rem 6.13rem;">
            <el-form-item label="帐号" prop="username">
              <el-input v-model="formLabelAlign.username"></el-input>
            </el-form-item>
            <el-form-item label="用户名" prop="nickname">
              <el-input v-model="formLabelAlign.nickname"></el-input>
            </el-form-item>
            <el-form-item label="初始密码" prop="password">
              <el-input type="password" v-model="formLabelAlign.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkpasswd">
              <el-input type="password" v-model="formLabelAlign.checkpasswd"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role">
              <el-select v-model="formLabelAlign.role" size="small">
                <el-option v-for="item in roleNameList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关联站点" prop="siteId" v-if="formLabelAlign.role == 3 || formLabelAlign.role == 2">
              <el-select v-model="formLabelAlign.siteId" multiple size="small">
                <el-option v-for="item in $store.state.siteList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

         
          </div>
        </el-form>
      </div>
 
        
      <div style="text-align: center; padding-top: 1rem">
        <button class="btn3" @click="register" :disabled="formLabelAlign.username === '' ||
          formLabelAlign.nickname === '' ||
          formLabelAlign.password === '' ||
          formLabelAlign.checkpasswd === '' ||
          formLabelAlign.role === '' ||
          formLabelAlign.password != formLabelAlign.checkpasswd
          ">
          确定
        </button>
        <button style="margin-left: 24px;" class="btn4" @click="closeDialog">取消</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import commonUtils from "@/utils/common";
import Pagination from "@/components/Pagination.vue";
import { sha256 } from 'js-sha256';

export default {
  components: { Pagination },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formLabelAlign.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      roleNameList: [{ id: 1, name: '超级管理员' }, { id: 2, name: '普通管理员' }, { id: 3, name: '普通管理员(温度)' }],
      visible: false,
      formLabelAlign: {
        username: "",
        nickname: "",
        password: "",
        checkpasswd: "",
        role: "",
        remark: "",
        siteIds: [],
      },
      options: [
        {
          value: "选项1",
          label: "重要",
        },
        {
          value: "选项2",
          label: "不重要",
        },
      ],
      rules: {
        username: [
          { required: true, message: "帐号不能为空", trigger: "blur" },
        ],
        nickname: [
          { required: true, message: "昵称不能为空", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        checkpasswd: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        role: [{ required: true, message: "角色不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    register() {
      const params = {
        username: this.formLabelAlign.username,
        nickname: this.formLabelAlign.nickname,
        password: this.formLabelAlign.password,
        role: this.formLabelAlign.role,
        siteIds: (this.formLabelAlign.role == 3 || this.formLabelAlign.role == 2) ? this.formLabelAlign.siteId.join() : '',
        // remark: this.formLabelAlign.remark
      };
      this.$api.user.register(params).then((res) => {
        if (res.code == 200) {
          this.$alert("添加新用户成功", "", {
            confirmButtonText: "确定",
            type: "success",
            center: true,
          }).then((action) => {
            if (action === "confirm") {
              this.$emit('getUserList')
              this.visible = false;
            }
          });
          // this.visible = false;
        } else {
          this.$alert(res.msg, "", {
            confirmButtonText: "确定",
            type: "warning",
            center: true,
          }).then((action) => {
            if (action === "confirm") {
              this.visible = false;
            }
          });
        }
      });
    },
    openDialog() {
    },
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.addUserDialog {
  /deep/.el-select__tags {
    overflow: hidden;
    width: 180px !important;
    flex-wrap: nowrap !important;
  }

  /deep/ .el-input {
    width: 16rem;
    margin-right: 24px;
  }

  /deep/ .el-input__inner {
    height: 32px !important;
    background: #E5E5E520 !important;
    border-radius: 4px;
    border: 1px solid #E5E5E520 !important;
    color: #44D7B6;
  }

  /deep/.el-textarea__inner {
    width: 16rem;
    background: #E5E5E520 !important;
    border-radius: 4px;
    border: 1px solid #E5E5E520 !important;
    color: #44D7B6;
  }

  /deep/ .el-select {
    width: 13.4375rem;
  }

  /deep/ .el-select-dropdown__wrap.el-scrollbar__wrap {
    overflow: auto;
    background-color: #244447;
    border: none;
  }

  /deep/ .el-select-dropdown {
    border: none;
  }

  /deep/ .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: var(--select-color1);
    background-color: #3f98a0;
  }

  /deep/ .el-select-dropdown__item.selected {
    color: var(--select-color1);
  }

  /deep/ .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.603);
  }

  /deep/ .el-form-item__label {
    color: var(--font-color1);
    font-size: .875rem;
  }

  /deep/ .pagination-container {
    text-align: center;
  }
}

//添加动画
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }

  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.pane-title {
  padding-left: 30px;
  font-size: 21px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #5bb3bc;
  line-height: 32px;
}
.btn-1 {
  margin-left: 15px;
  width: 4.6875rem;
    height: 1.875rem;
  background: #44d7b6;
  border-radius: 2px;
  color: #ffffff;
  border: none;
  cursor: pointer;
}

.btn3 {
  width: 8.125rem;
  height: 1.875rem;
  background: #219E82;
  border-radius: 0.125rem;
  border: 0.0625rem solid #219E82;
  color: white;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn3:hover {
  background: #44D7B6;
}
.btn4 {
  width: 8.125rem;
  height: 1.875rem;
  border-radius: 0.125rem;
  border: 0.0625rem solid #44D7B6;
  background: transparent;
  color: #44D7B6;
  font-size: 0.875rem;
  cursor: pointer;
  margin: 1.875rem 1.25rem;
}
.btn4:hover {
  background: #44D7B655;
}
</style>


// WEBPACK FOOTER //
// src/pages/systemSet/userManagement/addUserDialog.vue